export const mobile = {
  query: '(max-width: 828px)',
}

export const desktop = {
  query: '(min-width: 829px)',
}
